import { Box, Typography } from '@mui/material';
import ChatSignature from './ChatSignature';
import { useUserUpdaterProvider } from '../../../../context_providers/user_context/UserUpdaterProvider';
import COLORS from '../../../../resources/style/Themes';
import { EmergencyMessage } from '../../../../models/Emergency/EmergencyMessage';

interface DefaultMessageProps {
  chatData: EmergencyMessage;
}

function DefaultMessage({ chatData }: DefaultMessageProps) {
  const { orgUser } = useUserUpdaterProvider();
  const isUserMessage = chatData.sender_auth_id === orgUser?.auth_id;

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: isUserMessage ? 'flex-end' : 'flex-start',
        marginBottom: '10px',
        overflow: 'hidden',
      }}
    >
      <Box
        sx={{
          maxWidth: '70%',
          backgroundColor: isUserMessage
            ? COLORS.BLUE_CRAYOLA
            : COLORS.LIGHT_GRAY,
          color: isUserMessage ? COLORS.WHITE : 'black',
          borderRadius: isUserMessage ? '15px 15px 0 15px' : '15px 15px 15px 0',
          px: '12px',
          py: '6px',
          textAlign: isUserMessage ? 'right' : 'left',
        }}
      >
        <Typography variant="body1">{chatData.content}</Typography>
      </Box>
      {/* Move ChatSignature outside of the message box and align it to the right */}
      <ChatSignature chatData={chatData} />
    </Box>
  );
}

export default DefaultMessage;
